import CategoryNewsCard from "./CategoryNewsCard";

export default function CategoryList({ tagsData }) {
  return (
    <div className="space-y-6">
      {tagsData?.map((item, index) => (
        <CategoryNewsCard
          key={index}
          image={item?.thumbnail}
          title={item?.title}
          desc={item?.excerpt}
          href={item?.permalink}
          imageAlt={item?.thumbnail_alt}
          time={`${item?.date}`}
          isVideo={item?.is_video}
        />
      ))}
    </div>
  );
}
